import { Serializer } from "../resource/serializer.interface";
import { CoreContact } from "./core-contact.model";

export class CoreContactSerializer implements Serializer {

    fromJson(json: any): CoreContact {
        const coreContact = new CoreContact();
        coreContact.name = json.name;
        coreContact.type = json.type;
        coreContact.label = json.label;
        coreContact.description = json.description;
        coreContact.businessUnit = json.businessUnit;
        coreContact.preferenceCatalogId = json.preferenceCatalogId;
        coreContact.internalDescription = json.internalDescription;
        coreContact.customCSS = json.customCSS;
        coreContact.status = json.status;
        coreContact.tenantId = json.tenantId;
        coreContact.createdAt = json.createdAt;
        coreContact.updatedAt = json.updatedAt;
        coreContact.translations = json.translations ?? {};
        coreContact.isRequired = json.isRequired;
        coreContact.isEmailIdentifier = json.isEmailIdentifier;
        coreContact.id = json.id;


        return coreContact;
    }


    toJson(coreContact: CoreContact): any {
        return {
            id: coreContact.id,
            name: coreContact.name,
            type: coreContact.type,
            label: coreContact.label,
            description: coreContact.description,
            businessUnit: coreContact.businessUnit,
            preferenceCatalogId: coreContact.preferenceCatalogId,
            internalDescription: coreContact.internalDescription,
            customCSS: coreContact.customCSS,
            status: coreContact.status,
            tenantId: coreContact.tenantId,
            createdAt: coreContact.createdAt,
            updatedAt: coreContact.updatedAt,
            translations: coreContact.translations,
            isRequired: coreContact.isRequired,
            isEmailIdentifier: coreContact.isEmailIdentifier


        };
    }
}
